<template>
  <button role="button" @click="getAppleToken">
    <slot>
      <sns-logo-circle sns-name="apple" :width="60" :height="60" />
    </slot>
    <span class="a11y-hidden">Apple ID로 시작하기</span>
  </button>
</template>

<script setup>
  import SnsLogoCircle from '@/components/connection/sns/SnsLogoCircle.vue'
  import { onMounted } from 'vue'
  import { useRoute } from 'vue-router/composables'
  import { setLibFile } from '@/common/utils/common'
  import { setReferer } from '@/common/utils/referer'
  import cookie from '@/common/utils/cookie'
  import constant from '@/common/resources/constant'

  const route = useRoute()
  const emit = defineEmits(['success', 'fail'])

  const props = defineProps({
    useReferer: {
      type: Boolean,
      default: false,
    },
    useReturnUrl: {
      type: Boolean,
      default: true,
    },
  })

  const getAppleToken = () => {
    // setReferer: 상세의 로그인 팝업에서 로그인처리할 때 필요한 로직
    if (props.useReferer) {
      const referer = route.query?.referer || route.fullPath
      setReferer(referer)
    }

    AppleID.auth.init({
      clientId: 'kr.co.captv.pooqV2.member',
      scope: 'email',
      redirectURI: 'https://member.wavve.com/mobile/signup/mweb/apple',
      // response
      state: '',
      usePopup: false, // or false defaults to false
    })
    // apple 로그인 후 token, type을 query로 받아서 로그인 처리를 하는 케이스에 사용 (로그인 팝업을 제외한 나머지 케이스에서 사용)
    if (props.useReturnUrl) {
      cookie.setItem(
        'w-apple-login-return-url',
        location.href,
        null,
        constant.URL_COOKIE_DOMAIN,
        '/',
      )
    }
    AppleID.auth.signIn()
  }

  const init = () => {
    setLibFile(
      document,
      'script',
      'apple-login',
      '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/ko_KR/appleid.auth.js',
    )

    const { type, token } = route.query
    if (type === 'apple' && token) {
      emit('success', { token })
    }
  }

  onMounted(() => {
    init()
  })
</script>
